import { Link, Outlet } from "react-router-dom";
const Header = () => {
    return (
        <>
            <div className="header">
                <p className="title">The <img src={require("../unfold.png")} style={{ verticalAlign: "middle" }} width={50}></img><span className="text-gradient">Unfold</span> Playground</p>
                <p>A small, sandboxed scripting language for querying crypto wallets and tokengating content.</p>
                <Link to="/">
                    <button className="headerButton">playground</button>
                </Link>
                <div className="divider" />
                <Link to="/about">
                    <button className="headerButton">about</button>
                </Link>
            </div >
            <Outlet />
        </>
    );
}

export default Header;